import { api } from "@/client/api"

export default {
    validateApplicationData(providerKey, request, fieldIds) {
        return api.post("/validate", {
            providerKey,
            applicationData: request,
            fieldIds,
        })
    },

    validatePhoneNumber(phoneNumber) {
        return api.post("/validate/phone", {
            phoneNumber
        })
    },

    validateZipCodeState(zipCode, state) {
        return api.post("/validate/zipCode", {
            zipCode: zipCode,
            state: state,
        })
    },

    validateShortApplicantHash(ssn, dob, lastName) {
        return api.post("/validate/shortApplicantHash", {
            ssn: ssn,
            dob: dob,
            lastName: lastName
        })
    }
}
